import React from 'react'
import { Box } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { CircledText } from '~/components/CircledText'

const stepsLabel = ['IDENTIFICAÇÃO', 'SUA EMPRESA', 'SEU EMPRÉSTIMO', 'SEUS CONTATOS', 'CRIAR CONTA']

const useStyles = makeStyles({
  circledText: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: mutualTheme.spacing(5)
  }
})

export const StepIndicator: React.FC = () => {
  const classes = useStyles()

  const steps = stepsLabel.map((stepLabel, index) => (
    <Box className={classes.circledText} key={index}>
      <CircledText
        finished
        text={stepLabel}
        circleText={`${index + 1}`}
      />
    </Box>
  ))

  return (
    <Box>
      {steps}
    </Box>
  )
}
